var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.disabled
    ? _c(
        "el-avatar",
        _vm._b(
          {
            key: _vm.src,
            class: { "cursor-pointer": !_vm.disabled },
            style: { fontSize: _vm.fontSize, background: _vm.background },
            attrs: {
              slot: "reference",
              src: _vm.imageCache[_vm.src],
              size: _vm.size,
              fit: "fill",
            },
            slot: "reference",
          },
          "el-avatar",
          _vm.$attrs,
          false
        ),
        [_vm._v(_vm._s(_vm.showName))]
      )
    : _c(
        "el-popover",
        {
          attrs: {
            "visible-arrow": false,
            trigger: _vm.trigger,
            disabled: _vm.popoverDisabled,
            placement: "bottom",
            width: "250",
            "popper-class": "no-padding-popover",
          },
          model: {
            value: _vm.popoverShow,
            callback: function ($$v) {
              _vm.popoverShow = $$v
            },
            expression: "popoverShow",
          },
        },
        [
          _c("xr-user-view", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: { data: _vm.userData, src: _vm.imageCache[_vm.src] },
          }),
          _vm._v(" "),
          _c(
            "el-avatar",
            _vm._b(
              {
                key: _vm.src,
                class: { "cursor-pointer": !_vm.disabled },
                style: { fontSize: _vm.fontSize, background: _vm.background },
                attrs: {
                  slot: "reference",
                  src: _vm.imageCache[_vm.src],
                  size: _vm.size,
                  fit: "fill",
                },
                slot: "reference",
              },
              "el-avatar",
              _vm.$attrs,
              false
            ),
            [_vm._v(_vm._s(_vm.showName))]
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }